import React from "react";
import { VariantProps } from ".";
import LowestPriceGuarantee from "./LowestPriceGuarantee";
import { defaultChatObject } from "~/common/Store/rootReducer";
import useIsMounted from "~/common/useIsMounted";
import GoogleViewPrice from "../GoogleViewPrice";
import PlusShippingLevels from "../PlusShippingLevels";
import StandardPrice from "../StandardPrice";
import CreditKeyBanner from "~/ProductDetails/CreditKey/CreditKeyBanner";
import getPriceForGoogleView from "../getPriceForGoogleView";
import GetPriceByEmail from "./GetPriceByEmail";

const L = (props: VariantProps) => {
  const {
    price,
    itemNumber,
    minimumBuy,
    mustBuy,
    isGoogleView,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    user,
  } = props;

  const mounted = useIsMounted();

  const isInternalUser =
    user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";

  const creditKeyPrice = isGoogleView
    ? getPriceForGoogleView({
        price: price.price,
        minimumBuy,
        mustBuy,
      })
    : price.price;

  return (
    <div className="map map-override mapL">
      <div className="map__group">
        <LowestPriceGuarantee
          mounted={mounted}
          chat={defaultChatObject}
          itemNumber={itemNumber}
        />
        <div className="map__price">
          <label className="price__label">Retail Price</label>
          {isGoogleView ? (
            <GoogleViewPrice
              price={price.price}
              minimumBuy={minimumBuy}
              mustBuy={mustBuy}
              showCreditKey={false}
            />
          ) : (
            <StandardPrice
              price={price.price}
              unitOfMeasure=""
              showCreditKey={false}
            />
          )}
        </div>
      </div>
      <CreditKeyBanner price={creditKeyPrice} />
      <PlusShippingLevels
        hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping}
        allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping}
        isWebstaurantPlusEligible={isWebstaurantPlusEligible}
        user={user}
      />
      {isInternalUser && (
        <GetPriceByEmail email={user.emailAddress} itemNumber={itemNumber} />
      )}
    </div>
  );
};

export default L;
